import { Checkbox } from '@creditornot/cb-checkbox';
import styled from 'styled-components';

const LargeCheckBox = styled(Checkbox)`
  div:first-child {
    width: 24px;
    height: 24px;
  }

  svg {
    width: 20px;
  }
`;

export default LargeCheckBox;
